import React from 'react';
import { motion } from 'framer-motion';
export function BenefitsSection() {
  const benefits = [{
    icon: '🌙',
    title: 'DUERMES PROFUNDO',
    text: 'Ingredientes ricos en triptófano y magnesio que activan tu melatonina natural.'
  }, {
    icon: '⚡',
    title: 'METABOLISMO ACTIVO',
    text: 'Recetas de bajo índice glucémico que hacen que tu cuerpo queme grasa mientras duermes.'
  }, {
    icon: '🫃',
    title: 'VIENTRE PLANO AL DESPERTAR',
    text: 'Combinaciones anti-inflamatorias que eliminan la hinchazón nocturna desde la primera semana.'
  }, {
    icon: '⏱️',
    title: 'LISTAS EN MENOS DE 20 MIN',
    text: 'Diseñadas para personas ocupadas. Sin técnicas complicadas ni ingredientes exóticos.'
  }, {
    icon: '📅',
    title: 'UN AÑO RESUELTO',
    text: '365 cenas organizadas por estación del año. Nunca más la pregunta: ¿qué ceno hoy?'
  }, {
    icon: '💚',
    title: 'HORMONAS EN EQUILIBRIO',
    text: 'Fitoestrógenos y micronutrientes específicos para mujeres en perimenopausia y menopausia.'
  }];
  return <section className="w-full bg-sage-soft py-20 px-6" data-id="element-17">
      <div className="max-w-[1200px] mx-auto" data-id="element-18">
        <h2 className="font-serif text-3xl md:text-4xl text-botanic text-center mb-16" data-id="element-19">
          Lo que vas a lograr con tus 365 Cenas
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-20">
          {benefits.map((b, i) => <motion.div key={i} whileHover={{
          y: -5
        }} className="bg-white p-8 rounded-xl shadow-sm border border-sage/10 flex flex-col items-center text-center" data-id="element-21">
              <div className="text-4xl mb-4" data-id="element-22">{b.icon}</div>
              <h3 className="font-bold text-botanic text-lg mb-3" data-id="element-23">{b.title}</h3>
              <p className="text-ink-soft leading-relaxed" data-id="element-24">{b.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}